import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_CATEGORIES } from '../../graphql/queries';

const CategorySection = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';

    // Fetch categories
    const { data: categoriesData, loading, error } = useQuery(GET_CATEGORIES);

    // Get top categories (limit to 8 for the grid)
    const categories = categoriesData?.categories?.nodes?.slice(0, 8) || [];

    // Array of unique tag colors - one for each category
    const tagColors = [
        'tag-purple',
        'tag-green',
        'tag-red',
        'tag-blue',
        'tag-light-green',
        'tag-orange',
        'tag-lightblue',
        'tag-pink'
    ];

    // Fallback image for categories
    const getCategoryImage = () => {
        return publicUrl + 'assets/img/600x600bb-14.jpg';
    };

    if (loading) {
        return (
            <div className="pd-top-80 pd-bottom-50 go-top">
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <p>Loading categories...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        console.error('CategorySection Error:', error);
        return null;
    }

    return (
        <div className="pd-top-75 pd-bottom-50 go-top">
            <div className="container">
                <div className="section-title">
                    <h6 className="title">Categories</h6>
                </div>
                <div className="row">
                    {categories.map((category, index) => {
                        const tagColor = tagColors[index];

                        return (
                            <div className="col-lg-3 col-sm-6 mb-4" key={category.id}>
                                <Link to={`/category/${category.slug}`} className="single-post-wrap style-overlay category-box-small">
                                    <div className="thumb category-thumb-small">
                                        <img
                                            src={getCategoryImage()}
                                            alt={category.name}
                                        />
                                    </div>
                                    <div className="details">
                                        <div className="post-meta-single mb-2">
                                            <ul>
                                                <li>
                                                    <span className={`tag-base ${tagColor}`} style={{borderRadius: '20px', fontSize: '12px'}}>
                                                        {category.name}
                                                    </span>
                                                </li>
                                                <li>
                                                    <i className="fa fa-folder-o" />
                                                    {category.count} {category.count === 1 ? 'Post' : 'Posts'}
                                                </li>
                                            </ul>
                                        </div>
                                        <h6 className="title">
                                            {category.name}
                                        </h6>
                                        {category.description && (
                                            <p className="category-description">
                                                {category.description.substring(0, 60)}
                                                {category.description.length > 60 ? '...' : ''}
                                            </p>
                                        )}
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CategorySection;
